<script lang="ts">
	import { format } from 'svelte-i18n';
	import { createEventDispatcher } from 'svelte';

	import type { ApplianceType } from '../../../../helpers/device_settings_helpers';

	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	import SettingGuide from '../../SettingGuide.svelte';

	import { Text, Token, TokenV2 } from '@Shelly/shelly-design-system';

	import { getEnergyCategoryTypes } from '../../../../helpers/device_settings_helpers';
	import { calculateTokenWidthByTitle } from '../../../../helpers/utilities';

	export let selectedUsage: string | undefined;

	const dispatch = createEventDispatcher<{ select: ApplianceType }>();

	const types: ApplianceType[] = getEnergyCategoryTypes();

	$: TokenComponent = $showNewLayout ? TokenV2 : Token;

	const selectType = (type: ApplianceType): void => {
		dispatch('select', type);
	};
</script>

<SettingGuide
	text={$format('settings_guide_energy_category', {
		default:
			'Tells Shelly what this device powers so energy dashboards can group usage — lighting, heating, cooking, and so on.',
	})}
/>

<slot />

<Text styleType="body" class="mb-m">
	{$format('title_appliance_types', { default: 'Appliance types' })}
</Text>
<div class="d-flex flex-wrap gap-s mb-m">
	{#each types as type (type.usage)}
		<svelte:component
			this={TokenComponent}
			id={`token-appliance-${type.usage}`}
			size="m"
			title={type.title}
			class="text-nowrap"
			width={$showNewLayout ? undefined : calculateTokenWidthByTitle(type.title)}
			icon={`fas fa-${type.icon}`}
			selected={selectedUsage === type.usage}
			on:click={() => {
				selectType(type);
			}}
		/>
	{/each}
</div>
